import { render, staticRenderFns } from "./SectionPanelInfo.vue?vue&type=template&id=5725c8b7&scoped=true&"
import script from "./SectionPanelInfo.vue?vue&type=script&lang=js&"
export * from "./SectionPanelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5725c8b7",
  null
  
)

export default component.exports